import React from 'react'
import Header from './components/Header'

export default function NavBar() {
  return (
    <Header/>
  )
}
